<template>
  <div class="page-layout">
    <a-breadcrumb>
      <a-breadcrumb-item v-for="item in matched" :key="item.path">{{item.meta.title}}</a-breadcrumb-item>
    </a-breadcrumb>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'page-layout',

  data() {
    return {}
  },

  computed: {
    matched() {
      return this.$route.matched.filter(item => item.path !== '')
    }
  }
}
</script>

<style scoped lang="less">
.page-layout {
  width: 1300px;
  margin: 0 auto;
  padding-bottom: 24px;
  /deep/ .ant-breadcrumb {
    margin: 24px 0px;
  }
}
</style>
